import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {StorageService} from '../../services/storage/storage.service';
import {BaseRoutes} from "../../model/enum/routes.enum";

@Injectable({
  providedIn: 'root'
})
export class CatalogGuard implements CanActivate {
  constructor(
    private storageService: StorageService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // Allow access to order pages even for unauthenticated users
    if (state.url.includes('/order')) {
      return true;
    }

    // For other catalog pages, require authentication
    if (!this.storageService.getToken()) {
      this.router.navigate([BaseRoutes.LANDING]);
      return false;
    }

    // If user is authenticated, allow access to catalog
    return true;
  }
}
